import { render, staticRenderFns } from "./ReviewButton.vue?vue&type=template&id=e7a38c30&scoped=true"
import script from "./ReviewButton.vue?vue&type=script&lang=js"
export * from "./ReviewButton.vue?vue&type=script&lang=js"
import style0 from "./ReviewButton.vue?vue&type=style&index=0&id=e7a38c30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a38c30",
  null
  
)

export default component.exports